import {Link} from '@primer/react'

// eslint-disable-next-line no-restricted-imports
import progressBarStyles from '../../../../../client/components/fields/progress-bar/progress-bar.module.css'
import type {ParentIssue} from '../../../../api/common-contracts'
import {ItemType} from '../../../../api/memex-items/item-type'
import {useOpenParentIssue} from '../../../../features/sub-issues/use-open-parent-issue'
import type {FieldAggregate} from '../../../../hooks/use-aggregation-settings'
import {SubIssuesProgressBar} from '../../../fields/sub-issues-progress-bar'
import {ItemState} from '../../../item-state'
import {AggregateLabels} from '../../aggregate-labels'
import {SanitizedGroupHeaderText} from '../sanitized-group-header-text'
import styles from './parent-issue-group-header-label.module.css'

type Props = {
  parentIssue: ParentIssue
  rowCount: number
  hideItemsCount: boolean
  aggregates: Array<FieldAggregate>
  titleClassName?: string
}

export const ParentIssueGroupHeaderLabel: React.FC<Props> = ({
  parentIssue,
  rowCount,
  aggregates,
  hideItemsCount,
  titleClassName,
}) => {
  const {openParentIssue} = useOpenParentIssue()
  return (
    <>
      <ItemState
        isDraft={false}
        isBlocked={(parentIssue?.blockedByCount ?? 0) > 0}
        state={parentIssue.state}
        stateReason={parentIssue.stateReason}
        type={ItemType.Issue}
      />
      {parentIssue.url ? (
        <Link
          href={parentIssue.url}
          onClick={event => {
            // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
            if (event.metaKey || event.shiftKey || event.button === 1) return
            event.preventDefault()
            openParentIssue(parentIssue)
          }}
        >
          <ParentIssueTitle parentIssue={parentIssue} titleClassName={titleClassName} />
        </Link>
      ) : (
        <ParentIssueTitle parentIssue={parentIssue} titleClassName={titleClassName} />
      )}
      <AggregateLabels
        itemsCount={rowCount}
        aggregates={aggregates}
        hideItemsCount={hideItemsCount}
        counterClassName={styles.AggregateLabels}
      />
      {parentIssue.subIssueList && (
        <div className={progressBarStyles.container}>
          <SubIssuesProgressBar
            total={parentIssue.subIssueList.total}
            completed={parentIssue.subIssueList.completed}
            percentCompleted={parentIssue.subIssueList.percentCompleted}
          />
        </div>
      )}
    </>
  )
}

const ParentIssueTitle: React.FC<Pick<Props, 'parentIssue' | 'titleClassName'>> = ({parentIssue, titleClassName}) => {
  const titleHtml = parentIssue.titleHtml

  return (
    <>
      <SanitizedGroupHeaderText titleHtml={titleHtml} className={titleClassName} />{' '}
      <span className={styles.ParentIssueTitle}>#{parentIssue.number}</span>
    </>
  )
}
